<template>
  <div class="selffoot-box">
    <router-link class="selffoot-boxitem" :to="{name:'comment', query: paramInfo}">
      <div>
        <img src="@/assets/icon/icon-pinglun.png" />
      </div>
      <div>评论</div>
    </router-link>
    <!-- <div class="selffoot-boxitem">
      <div>
        <img src="@/assets/icon/icon-xiazai.png" />
      </div>
      <div>下载</div>
    </div>-->
    <!-- <div class="selffoot-boxitem">
      <div>
        <img src="@/assets/icon/icon-dayin.png" />
      </div>
      <div>打印</div>
    </div>
    <div class="selffoot-boxitem">
      <div>
        <img src="@/assets/icon/icon-chehui.png" />
      </div>
      <div>撤回</div>
    </div>-->
    <div @click="Urge" class="selffoot-boxitem">
      <div>
        <img src="@/assets/icon/icon-cuiban.png" />
      </div>
      <div>催办</div>
    </div>
  </div>
</template>
<script>
import * as dd from "dingtalk-jsapi";
import { mapState } from "vuex";
const { Client_APP_URL, menuItem } = require(`@/config/develop.json`);
export default {
  computed: {
    ...mapState({
      dingdingconfig: state => state.dingdingconfig
    })
  },
  props: {
    paramInfo: {},
    urgeInfo: {}
  },
  methods: {
    Urge() {
      debugger;
      let _this = this;
      let path = _this.urgeInfo.path
        ? _this.urgeInfo.path
        : menuItem[_this.paramInfo.applyTypeId];
      let mainurl = Client_APP_URL.substring(
        0,
        Client_APP_URL.lastIndexOf("/")
      );
      let url = `${mainurl + path}?applyId=${
        _this.paramInfo.applyId
      }&applyTypeId=${_this.paramInfo.applyTypeId}&dd_full_screen=true`;
      console.log(url);
      dd.biz.ding.create({
        users: _this.urgeInfo.approverUserId.split(), // 用户列表，工号
        corpId: _this.dingdingconfig.corpId, // 企业id
        type: 2, // 附件类型 1：image  2：link
        alertType: 2, // 钉发送方式 0:电话, 1:短信, 2:应用内
        alertDate: { format: "yyyy-MM-dd HH:mm", value: "2015-05-09 08:00" },
        attachment: {
          title: `待办任务通知`, //附件的标题
          url: url, //附件点击后跳转url
          text: _this.urgeInfo.applyEmployeeName,
          showInApp: true
        }, // 附件信息
        text: `${_this.urgeInfo.applyEmployeeName}提醒您审批他的${_this.urgeInfo.applyTypeName}`, // 正文
        onSuccess: function() {
          //onSuccess将在点击发送之后调用
        },
        onFail: function() {}
      });
    }
  }
};
</script>
<style lang="less" scoped>
.selffoot-box {
  display: flex;
  justify-content: space-around;
  margin-top: 0.2rem;
  .selffoot-boxitem {
    display: block;
    font-size: 0.293333rem;
    color: #666666;
    text-align: center;
    img {
      width: 0.64rem;
      height: 0.64rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Approval/ApprovalFoot/approvalSelfFoot.vue